import React from 'react'
import axios from 'axios'

import Button from '../Form/Button'

export default class Chamado extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            ficha: {}
        }
    }

    componentDidMount() {
        const id = this.props.match.params.id
        const url = `/api/suporte/getChamado/${id}`
        axios(url)
            .then(resp => {
                this.setState({ ficha: resp.data })
            })
            .catch(error => {
                alert(error.response.data)
            }
            )
    }

    render() {
        return (
            <div className="container mx-auto">
                <div className="form-group row pt-3 text-left">
                    <label className="col-3 col-md-2">Usuário:</label>
                    <div className="col-9 col-md-4 mb-3">
                        <input type="text" className="form-control" value={localStorage.nome} />
                    </div>
                    <label className="col-3 col-md-2">Tipo:</label>
                    <div className="col-9 col-md-4 mb-3">
                        <input type="text" className="form-control" value={this.state.ficha.tipo} />
                    </div>
                    <label className="col-12">Texto:</label>
                    <div className="form-control textarea text-left">{this.state.ficha.mensagem}</div>
                </div>
                <br /><hr /><br />
                <div className="form-group row mt-3 text-left">
                    <label className="col-12">Resposta:</label>
                    <div className="form-control textarea text-left">{this.state.ficha.resposta}</div>
                </div>
            </div>
        )
    }
}